import { apiFetch } from "./api";

export interface LoginResponse {
	token: string;
	refresh_token: string;
	user_id: string;
	name: string;
	role: string;
	active: boolean;
	phone: string;
}

export interface RefreshResponse {
	token: string;
	refresh_token: string;
}

export function loginRequest(email: string, password: string) {
	return apiFetch<LoginResponse>("/login", {
		method: "POST",
		body: JSON.stringify({ email, password }),
		credentials: "include",
	});
}

export function validateTokenRequest(token: string) {
	return apiFetch<void>("/validate-token", {
		method: "POST",
		body: JSON.stringify({ token }),
	});
}

export function refreshRequest() {
	// Cookie is sent automatically by the browser (httpOnly), but only if
	// credentials is "include" — API and frontend are different origins in
	// local dev (different ports), and fetch defaults to "same-origin".
	return apiFetch<RefreshResponse>("/refresh", {
		method: "POST",
		skipAuth: true,
		credentials: "include",
	});
}

export function logoutRequest() {
	return apiFetch<void>("/logout", {
		method: "POST",
		skipAuth: true,
		credentials: "include",
	});
}
